import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import richTextFragment from '@components/renderers/rich-text.fragment'
import Contact from './contact'

const QUERY = gql`
query  {
  contactCollection(limit: 1) {
    items {
      heroImage {
        url
      }
      heroText
      headline
      body {
        ${richTextFragment}
      }
      acceptMessage {
        ${richTextFragment}
      }
      messageSuccess
      messageError
      addressEyebrow
      addressHeadline
      address1
      address2
      phone
      metaTitle
      metaImage {
        url
      }
    }
  }
}
`

export default function ContactWithData(props) {
  return (
    <Query query={QUERY}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data && data.contactCollection
          && data.contactCollection.items
          && data.contactCollection.items[0]

        return response ? (
          <Contact {...props} {...response} />
        ) : <Contact {...props} {...response} />
      }}
    </Query>
  )
}
